(() => {
  const container = document.getElementById('fomo-collapsible-product-description');
  if (!container) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'fomo-content-wrapper';
  while (container.firstChild) wrapper.appendChild(container.firstChild);
  container.appendChild(wrapper);

  const style = document.createElement('style');
  style.textContent = `
    #fomo-collapsible-product-description {
      position: relative;
    }
    #fomo-collapsible-product-description .fomo-content-wrapper {
      transition: max-height 0.3s ease;
    }
    #fomo-collapsible-product-description.collapsed .fomo-content-wrapper {
      max-height: 100px;
      overflow: hidden;
    }
    #fomo-collapsible-product-description.collapsed::before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 2em;
      width: 100%;
      height: 3em;
      pointer-events: none;
      background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1));
    }
    .fomo-read-more-btn {
      background: none;
      border: none;
      padding: 0;
      margin-top: 1em;
      font: inherit;
      text-decoration: underline;
      cursor: pointer;
    }
  `;
  document.head.appendChild(style);

  container.classList.add('collapsed');

  const btn = document.createElement('button');
  btn.className = 'fomo-read-more-btn';
  btn.setAttribute('aria-expanded', 'false');
  btn.textContent = 'Read more';
  btn.addEventListener('click', () => {
    const isCollapsed = container.classList.toggle('collapsed');
    btn.setAttribute('aria-expanded', (!isCollapsed).toString());
    btn.textContent = isCollapsed ? 'Read more' : 'Read less';
  });
  container.appendChild(btn);
})();